import { Money } from '@rygen/rygen-ui/model';

export class MoneyUtil {
  /**
   * Check if two Money objects are equivalent
   * @param a
   * @param b
   */
  static equals(a?: Money, b?: Money) {
    return a?.amount === b?.amount && a?.currency === b?.currency;
  }

  /**
   * Clone a Money object
   * @param money
   * @returns a new Money object with the same value as the input Money object or undefined if the input is undefined
   */
  static clone(money?: Money): Money | undefined {
    return money ? new Money(money) : undefined;
  }
}

export default MoneyUtil;
